import { getLocalStorageValue } from "@/utils/common";

export const unleashConfig = {
  url: process.env.NEXT_PUBLIC_UNLEASH_PROXY_URL as string,
  clientKey: process.env.NEXT_PUBLIC_UNLEASH_CLIENT_KEY as string,
  appName: 'curiousjr-web',
  refreshInterval: 900, // in seconds
  environment: process.env.NEXT_PUBLIC_ENV as string,
  ...(getLocalStorageValue('user', {})?.id
    ? { context: { userId: getLocalStorageValue('user', {})?.id as string } }
    : {}),
}
